import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionLogos = document.querySelectorAll('section.logos');

document.addEventListener('DOMContentLoaded', () => {
	sectionLogos.forEach((section) => {
		if (section.querySelector('.swiper-logos')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper-logos`;
			const swiperElement = document.querySelector(swiperId);
			const amount = parseInt(swiperElement.getAttribute('data-count'), 10);
			const navigation = swiperElement.getAttribute('data-navigation') === '1';
			const desktopAmount = 5;
			const loopSwiper = amount > desktopAmount;

			let swiperSettings = {
				modules: [Navigation, Pagination, A11y],
				a11y: true,
				grabCursor: true,
				loop: loopSwiper,
				slidesPerView: 2,
				spaceBetween: 16,
				freeMode: false,
				speed: 400,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: `#${sectionId} .swiper-btn-next`,
					prevEl: `#${sectionId} .swiper-btn-prev`,
				},
				pagination: {
					el: `#${sectionId} .swiper-pagination`,
					clickable: true,
				},
				breakpoints: {
					760: {
						slidesPerView: 4,
					},
					1024: {
						slidesPerView: desktopAmount,
					},
				},
			};

			if (!navigation) {
				swiperSettings.freeMode = true;
				swiperSettings.speed = 10000;
				swiperSettings.autoplay = {
					delay: 0.5,
					pauseOnMouseEnter: false,
				};
			}

			const swiper = new Swiper(swiperId, swiperSettings);

			if (window.innerWidth > 1024 && amount < 6) {
				swiperElement.classList.add('no-slider');
			} else {
				swiperElement.classList.remove('no-slider');
			}
		}
	});
});
